import {CommandId, IconSpec, StoreKey, WorkbenchCommandHandler, WorkbenchViewVisibilityKind} from '../types';
import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs';

export interface StoreBinding {
    type: 'store';
    storeKey: StoreKey;
}

export interface WorkbenchCommandConfig {
    internal?: boolean; // default: false
    name?: string;
    icon?: IconSpec;
    description?: string;
    category?: string;
    visibility?: WorkbenchViewVisibilityKind;
    params?: any;
    statusBindings?: { [statusId: string]: StoreBinding };
}

@Injectable()
export class WorkbenchCommandRegistry {
    commandHandlers: { [commandId: string]: WorkbenchCommandHandler } = {};
    commandConfigs$ = new BehaviorSubject<{ [commandId: string]: WorkbenchCommandConfig }>({});

    commandExecutions$ = new Subject<{ commandId: CommandId, params: any }>();

    constructor() {
    }

    registerCommand(commandId: CommandId, config: WorkbenchCommandConfig, handler: Function | WorkbenchCommandHandler): void {
        this.commandConfigs$.next({
            ...this.commandConfigs$.getValue(),
            [commandId]: config
        });

        if (typeof handler === 'function') {
            this.commandHandlers[commandId] = {
                handleCommand: (id: CommandId, params): any => handler(params)
            };
        } else {
            this.commandHandlers[commandId] = handler;
        }
    }

    subscribeToCommandEvents$(): Observable<{ [commandId: string]: WorkbenchCommandConfig }> {
        return this.commandConfigs$.asObservable();
    }

    subscribeToCommandExecutions$(): Observable<{ commandId: CommandId, params: any }> {
       return this.commandExecutions$.asObservable();
    }

    getCommandConfig(commandId: CommandId): WorkbenchCommandConfig | undefined {
        return this.commandConfigs$.getValue()[commandId];
    }

    /**
     * Execute command if handler is registered.
     */
    executeCommand(commandId: CommandId, params?: any): any {
        const handler = this.commandHandlers[commandId];
        if (!handler) {
            return;
        }
        this.commandExecutions$.next({ commandId, params });
        return handler.handleCommand(commandId, params);
    }
}
